// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!lato-font/css/lato-font.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".WU12RNuG7NJOrkYJJmbpr{display:flex;flex-direction:column;align-items:flex-end}._2SJCHdRP3RGP-BL9mSUxQu{height:75px}._2wpcy-I5mFxcDsG4r58-ic{height:160px}.defaultTheme ._2wpcy-I5mFxcDsG4r58-ic{border-color:#f0f0f0}.tenantTheme ._2wpcy-I5mFxcDsG4r58-ic{border-color:#f0f0f0}.defaultDarkTheme ._2wpcy-I5mFxcDsG4r58-ic{border-color:#111}.tenantDarkTheme ._2wpcy-I5mFxcDsG4r58-ic{border-color:#111}.subTenantTheme ._2wpcy-I5mFxcDsG4r58-ic{border-color:#f0f0f0}.subTenantDarkTheme ._2wpcy-I5mFxcDsG4r58-ic{border-color:#111}._3FPV6SD9WmdMhAM4vrTj-C{display:flex}.B1GHU0AE4QliXFGifKKH2{margin:20px 0}._2PW7ujqmSmBW9ijCt7WDoX{padding-left:12px;width:200px}.ctmiAAPZLxlE1B-k45-ys{width:240px}.ctmiAAPZLxlE1B-k45-ys:hover{cursor:pointer}._3_RvpBWsXSi-NstDf8bwS4{min-width:88px;min-height:51px;margin-bottom:20px;margin-top:20px}._3Zx4LMNnerN-qixyFDMSM1{width:1200px}.WSuU44j8fMaGUOVSszVZe label{display:block;margin-bottom:12px}._3sPLsPa4dotuplZSE0JfEW{padding:0 0 20px 0}._2qGHVMFSC74qqm4fNQq2K8{display:flex;justify-content:center}._36PHk1CJSdjVZT0MHxcara{display:inline-flex;margin-left:10px;position:absolute}.MGSG3S4RRw8s6OOruyTqv{padding:0 5px 5px 0}._3Scg6GbhkuCodUfkCJo_p-{width:237px}.defaultTheme ._3Scg6GbhkuCodUfkCJo_p-{color:#99a4ae}.tenantTheme ._3Scg6GbhkuCodUfkCJo_p-{color:#99a4ae}.defaultDarkTheme ._3Scg6GbhkuCodUfkCJo_p-{color:#4c4c4c}.tenantDarkTheme ._3Scg6GbhkuCodUfkCJo_p-{color:#4c4c4c}.subTenantTheme ._3Scg6GbhkuCodUfkCJo_p-{color:#99a4ae}.subTenantDarkTheme ._3Scg6GbhkuCodUfkCJo_p-{color:#4c4c4c}._3Scg6GbhkuCodUfkCJo_p-:hover{cursor:not-allowed}._91TpXa1rJVsrTKzwVAHh1{padding:10px 15px 10px 15px !important;margin-bottom:15px !important;text-align:justify;border-radius:3px;border-width:0px;opacity:1.6 !important;font:normal normal normal 10px/11px Lato;letter-spacing:0px;cursor:pointer}.defaultTheme ._91TpXa1rJVsrTKzwVAHh1{color:#fff}.tenantTheme ._91TpXa1rJVsrTKzwVAHh1{color:#fff}.defaultDarkTheme ._91TpXa1rJVsrTKzwVAHh1{color:#4c4c4c}.tenantDarkTheme ._91TpXa1rJVsrTKzwVAHh1{color:#4c4c4c}.subTenantTheme ._91TpXa1rJVsrTKzwVAHh1{color:#fff}.subTenantDarkTheme ._91TpXa1rJVsrTKzwVAHh1{color:#4c4c4c}.defaultTheme ._91TpXa1rJVsrTKzwVAHh1{background-color:#4c4c4c}.tenantTheme ._91TpXa1rJVsrTKzwVAHh1{background-color:#4c4c4c}.defaultDarkTheme ._91TpXa1rJVsrTKzwVAHh1{background-color:#f0f0f0}.tenantDarkTheme ._91TpXa1rJVsrTKzwVAHh1{background-color:#f0f0f0}.subTenantTheme ._91TpXa1rJVsrTKzwVAHh1{background-color:#4c4c4c}.subTenantDarkTheme ._91TpXa1rJVsrTKzwVAHh1{background-color:#f0f0f0}._91TpXa1rJVsrTKzwVAHh1:after{border-left:0 !important;border-right:0 !important}._2WvWMok5guv1ZI3HLSP52N{margin-bottom:32px}._1F3s7AK0lTepWq_1la9xa8{display:flex}._1F3s7AK0lTepWq_1la9xa8 div{flex:1;text-align:center}._3Hji3FFeFka0V2Q6f_107-{display:flex;flex-direction:column;gap:32px}.TCGUhbU-LUedgr9fnVogY{display:grid;grid-template-columns:120px 1fr;gap:20px}._2bBcaEH_tMy9CTJlK5umFu{display:flex;row-gap:12px;column-gap:8px;flex-wrap:wrap}.DNue-M3I034EjWnLrPKIm{display:flex;align-items:center;padding:2px 8px 2px 4px;border-radius:12px;font:normal normal normal 12px/12px Lato;transition:250ms opacity}.defaultTheme .DNue-M3I034EjWnLrPKIm{background-color:#f0f0f0}.tenantTheme .DNue-M3I034EjWnLrPKIm{background-color:#f0f0f0}.defaultDarkTheme .DNue-M3I034EjWnLrPKIm{background-color:#4c4c4c}.tenantDarkTheme .DNue-M3I034EjWnLrPKIm{background-color:#4c4c4c}.subTenantTheme .DNue-M3I034EjWnLrPKIm{background-color:#f0f0f0}.subTenantDarkTheme .DNue-M3I034EjWnLrPKIm{background-color:#4c4c4c}.defaultTheme .DNue-M3I034EjWnLrPKIm{color:#111}.tenantTheme .DNue-M3I034EjWnLrPKIm{color:#111}.defaultDarkTheme .DNue-M3I034EjWnLrPKIm{color:#fff}.tenantDarkTheme .DNue-M3I034EjWnLrPKIm{color:#fff}.subTenantTheme .DNue-M3I034EjWnLrPKIm{color:#111}.subTenantDarkTheme .DNue-M3I034EjWnLrPKIm{color:#fff}.DNue-M3I034EjWnLrPKIm._1tOVkoUtn9ZkzwhR7hlRdF{opacity:.2;transition:250ms opacity;pointer-events:none}.DNue-M3I034EjWnLrPKIm span{margin-left:4px}._2n45Qcnz7cYkuhAO-2npDu{display:flex;align-items:center;gap:2px}._2n45Qcnz7cYkuhAO-2npDu ._2vqzpH8ySi8wO82s4lB5uW{margin-left:2px;font-size:10px}._1fLy9x2iLIVDIIQGc0u9EF{margin-bottom:0;list-style-type:none}._1fLy9x2iLIVDIIQGc0u9EF li{display:flex;align-items:center}._1fLy9x2iLIVDIIQGc0u9EF li:not(:last-child){padding-bottom:4px}._1fLy9x2iLIVDIIQGc0u9EF li::marker{margin:0}._1fLy9x2iLIVDIIQGc0u9EF ._2r0JGR2FHxpWxEAUPGYyAK{display:flex;width:20px;justify-content:center}", ""]);
// Exports
exports.locals = {
	"breakpointSm": "580px",
	"breakpointMd": "768px",
	"breakpointLg": "992px",
	"breakpointXl": "1200px",
	"breakpointXxl": "1600px",
	"whiteColor": "#fff",
	"homeViewTierTypeLabelTextColor": "#cecece",
	"homeCurrentPlanRedColor": "#362f3f",
	"homeCurrentPlanBlueColor": "#1d2d36",
	"homeCurrentPlanYellowColor": "#3b3025",
	"homeCardTextColor": "#8e8e8e",
	"homeSupportBadgeTextColor": "#91b9f0",
	"homeSupportBadgeColor": "#282828",
	"homeCardVersionColor": "#8e8e8e",
	"homeCardBackgroundColor": "#282828",
	"homeCardBorderColor": "#303030",
	"homeCardNameColor": "#cecece",
	"homeIconsColor": "#91b9f0",
	"homeWireIconColor": "#403aac",
	"homeWireIconBackgroundColor": "#a8a3ff",
	"homeInfoBadgeColor": "#606060",
	"activeBackgroundColor": "#476c86",
	"activeForegroundColor": "#476c86",
	"primaryButtonBackgroundColor": "#476c86",
	"secondaryButtonForegroundColor": "#91b9f0",
	"bannerBackgroundColor": "rgba(71,108,134,.5)",
	"linkTextColor": "#5f96bc",
	"primaryButtonBackgroundHoverColor": "#5f96bc",
	"secondaryButtonBackgroundHoverColor": "#354057",
	"destructiveButtonBackgroundHoverColor": "#c12020",
	"destructiveButtonActiveBackgroundColor": "#db2828",
	"primaryButtonBackgroundActiveColor": "#222",
	"secondaryButtonBackgroundActiveColor": "#273044",
	"destructiveButtonBackgroundColor": "#a51313",
	"navigationButtonBackgroundActiveColor": "#2e384f",
	"chartNegativeColor": "#f09191",
	"chartPositiveColor": "#5fe3a1",
	"chartNeutralColor": "#cecece",
	"errorBackgroundColor": "#f46464",
	"errorBorderColor": "#f46464",
	"errorTextColor": "#f46464",
	"errorWrapperBackgroundColor": "#f2c5c5",
	"warningBackgroundColor": "#e47530",
	"warningBorderColor": "#e47530",
	"warningTextColor": "#e47530",
	"secondaryWarningBackgroundColor": "#ffc915",
	"secondaryWarningBorderColor": "#ffc915",
	"secondaryWarningTextColor": "#ffc915",
	"successBorderColor": "#5fe3a1",
	"successTextColor": "#5fe3a1",
	"pageBackgroundColor": "#222",
	"wrapperBackgroundColor": "#dfe4f2",
	"urlSectionBackgroundColor": "#dfe4f2",
	"wrapperBorderColor": "#a1b0d5",
	"modelBoxBackgroundColor": "#4c4c4c",
	"contentBackgroundColor": "#333",
	"secondaryButtonBackgroundColor": "#333",
	"textColor": "#fff",
	"textGreyColor": "#8e8e8e",
	"primaryButtonForegroundColor": "#fff",
	"bannerForegroundColor": "#4c4c4c",
	"chartOutlineColor": "#222",
	"modalOverlayColor": "rgba(34,34,34,.4)",
	"contentDividerColor": "#111",
	"contentBorderColor": "#111",
	"nestedContentBorderColor": "#cecece",
	"disabledButtonBackgroundColor": "#cecece",
	"disabledButtonForegroundColor": "#4c4c4c",
	"inputHintColor": "#cecece",
	"inputBackgroundColor": "#4c4c4c",
	"hoverBackgroundColor": "#111",
	"toggleCheckedBackgroundColor": "#91b9f0",
	"toggleUncheckedBackgroundColor": "#cecece",
	"toggleForegroundColor": "#fff",
	"mapForegroundColor": "#f0f0f0",
	"mapBackgroundColor": "#222",
	"emptyStateEllipseBackgroundColor": "#494949",
	"emptyStateBiggestCircleBackgroundColor": "#484848",
	"emptyStateSmallestCircleBackgroundColor": "#4b4b4b",
	"emptyStatePersonColor": "#4a4a52",
	"emptyStatePersonShirtColor": "#91b9f0",
	"emptyStatePersonSleeveColor": "#3b5dab",
	"emptyStateEllipseBackgroundOpacity": ".599",
	"emptyStateBiggestCircleBackgroundOpacity": ".197",
	"emptyStateSmallestCircleBackgroundOpacityFirst": ".401",
	"emptyStateSmallestCircleBackgroundOpacitySecond": ".602",
	"emptyStateSmallestCircleBackgroundOpacityThird": ".846",
	"chartFirstSet": "#708add",
	"chartSecondSet": "#dd75a0",
	"chartThirdSet": "#4a7ab6",
	"chartForthSet": "#5f96bc",
	"chartFifthSet": "#c4874a",
	"chartSixthSet": "#b63e5c",
	"chartSeventhSet": "#6c8fa9",
	"chartEighthSet": "#f3a14e",
	"chartNinthSet": "#88bbdb",
	"chartTenthSet": "#e2afc3",
	"chartEleventhSet": "#b1bfde",
	"chartTwelfthSet": "#facf96",
	"optional": "#fff",
	"disabledTextColor": "#4c4c4c",
	"colorPickerBlack": "#000",
	"iconFillColor": "#91b9f0",
	"sortIconRegularColor": "#cecece",
	"sortIconHoverColor": "#5f96bc",
	"sortIconActiveColor": "#fff",
	"calendarRangeBackgroundColor": "#91b9f0",
	"selectedTabColor": "#91b9f0",
	"basicTierBannerColor": "rgba(188,132,74,.0980392157)",
	"basicTierBannerBorderColor": "#9d6f3f",
	"premiumTierBannerColor": "rgba(107,149,184,.0980392157)",
	"premiumTierBannerBorderColor": "#6b95b8",
	"diamondTierBannerColor": "rgba(181,78,119,.0980392157)",
	"diamondTierBannerBorderColor": "#b54e77",
	"starTierBannerBorderColor": "#6f53e0",
	"chartSuccessColor": "#009e57",
	"chartFailColor": "#db3737",
	"notVerified": "#708add",
	"textFieldColor": "#111",
	"focusOutlineColorInput": "#3b5dab",
	"focusOutlineColorButton": "#d661e5",
	"tooltipTextColor": "#4c4c4c",
	"tooltipBackgroundColor": "#f0f0f0",
	"chipBackgroundColor": "#4c4c4c",
	"chipContentColor": "#fff",
	"chipUserIconColor": "#111",
	"successIconColor": "#5fe3a1",
	"errorIconColor": "#f09191",
	"localBannerBackgroundColor": "#33405f",
	"localBannerBorderColor": "#2d2d2d",
	"errorBannerBackgroundColor": "#f1a9a9",
	"localBannerTextColor": "#fff",
	"successBadgeBackgroundColor": "#006f1f",
	"successBadgeTextColor": "#e5f2e9",
	"warningBadgeBackgroundColor": "#ffda5c",
	"warningBadgeTextColor": "#715907",
	"errorBadgeBackgroundColor": "#9c2a2a",
	"errorBadgeTextColor": "#fff",
	"infoBadgeBackgroundColor": "#374f86",
	"infoBadgeTextColor": "#fff",
	"infoIconBackgroundColor": "#f0f0f0",
	"neutralBadgeBackgroundColor": "#606060",
	"neutralBadgeTextColor": "#fff",
	"strokeColor": "#364c7d",
	"textHighlightForegroundColor": "linear-gradient(0deg, rgba(255, 201, 21, 0.3) 0%, rgba(255, 201, 21, 0.3) 100%)",
	"textHighlightBackgroundColor": "#fff",
	"skeletonLoaderBackgroundColor": "#222",
	"firstLevelTierBackgroundColor": "#fff6ee",
	"secondLevelTierBackgroundColor": "#f2faff",
	"thirdLevelTierBackgroundColor": "#fff8fb",
	"fourthLevelTierBackgroundColor": "#6f53e0",
	"defaultStarColor": "#007b22",
	"userDefaultStarColor": "#cecece",
	"addOnsCheckmarkColor": "#5fe3a1",
	"warningBannerBackgroundColor": "#ffd95b",
	"warningBannerBorderColor": "#fff1c1",
	"warningBannerTextColor": "#111",
	"warningIconBackgroundColor": "#111",
	"warningIconExclamationColor": "#ffc915",
	"hoverColor": "rgba(71,108,134,.3)",
	"navigationButtonBackgroundHoverColor": "#2b303c",
	"conditionToggleButtonBackgroundColor": "#222",
	"conditionToggleButtonBorderColor": "#4c4c4c",
	"conditionTableBackgroundColor": "#222",
	"conditionTableBorderColor": "#4c4c4c",
	"conditionTableNestedBackgroundColor": "#111",
	"tabHoverColor": "#4c4c4c",
	"modularPurpleColor": "#b9a8ff",
	"modularBackgroundPurpleColor": "#41366e",
	"readyToUseSkyBlueColor": "#72bcf8",
	"readyToUseBackgroundBlueColor": "#1b364c",
	"readyToUseBorderBlueColor": "#0c62a8",
	"modularBorderPurpleColor": "#53429c",
	"descriptionTextColor": "#8e8e8e",
	"lightGreenBackgroundColor": "#e5f2e9",
	"lightBlueBackgroundColor": "#e0e5f3",
	"errorBannerColor": "#f1a9a9",
	"errorBannerTextColor": "#4c4c4c",
	"bannerIconBackgroundColor": "#db2828",
	"bannerIconColor": "#fff",
	"accordianSuccessBackgroundColor": "#183d22",
	"accordianSuccessBorderColor": "#096422",
	"accordianSuccessTextColor": "#5fe3a1",
	"homeCurrentPlanLabelTextColor": "#606060",
	"cardBorderColor": "#4c4c4c",
	"hoverCardBorderColor": "#8e8e8e",
	"defaultTheme": "defaultTheme",
	"tenantTheme": "tenantTheme",
	"defaultDarkTheme": "defaultDarkTheme",
	"tenantDarkTheme": "tenantDarkTheme",
	"subTenantTheme": "subTenantTheme",
	"subTenantDarkTheme": "subTenantDarkTheme",
	"descriptionContainer": "WU12RNuG7NJOrkYJJmbpr",
	"descriptionHeight": "_2SJCHdRP3RGP-BL9mSUxQu",
	"tabPanel": "_2wpcy-I5mFxcDsG4r58-ic",
	"tabContainer": "_3FPV6SD9WmdMhAM4vrTj-C",
	"rolesCheckbox": "B1GHU0AE4QliXFGifKKH2",
	"labelPadding": "_2PW7ujqmSmBW9ijCt7WDoX",
	"labelMargin": "ctmiAAPZLxlE1B-k45-ys",
	"okButton": "_3_RvpBWsXSi-NstDf8bwS4",
	"fixedWidthModal": "_3Zx4LMNnerN-qixyFDMSM1",
	"reportTarget": "WSuU44j8fMaGUOVSszVZe",
	"resultContainer": "_3sPLsPa4dotuplZSE0JfEW",
	"okButtonContainer": "_2qGHVMFSC74qqm4fNQq2K8",
	"loaderContainer": "_36PHk1CJSdjVZT0MHxcara",
	"viewCheckIcon": "MGSG3S4RRw8s6OOruyTqv",
	"disabledText": "_3Scg6GbhkuCodUfkCJo_p-",
	"tooltip": "_91TpXa1rJVsrTKzwVAHh1",
	"authorityFilter": "_2WvWMok5guv1ZI3HLSP52N",
	"authorityErrorMessage": "_1F3s7AK0lTepWq_1la9xa8",
	"authorityContainer": "_3Hji3FFeFka0V2Q6f_107-",
	"authorityContent": "TCGUhbU-LUedgr9fnVogY",
	"authorityContentRow": "_2bBcaEH_tMy9CTJlK5umFu",
	"chip": "DNue-M3I034EjWnLrPKIm",
	"disabled": "_1tOVkoUtn9ZkzwhR7hlRdF",
	"chipGroupIcons": "_2n45Qcnz7cYkuhAO-2npDu",
	"remainingGroups": "_2vqzpH8ySi8wO82s4lB5uW",
	"groupIconsTooltip": "_1fLy9x2iLIVDIIQGc0u9EF",
	"icon": "_2r0JGR2FHxpWxEAUPGYyAK"
};
module.exports = exports;
